import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const channelRouter: Array<RouteRecordRaw> = [
    {
        path: '/channel',
        component: Layout,
        name: '渠道配置',
        redirect: '/channel/out-list',
        meta: { title: '渠道配置', icon: 'icon-channel', alwaysShow: true },
        children: [
            {
                path: 'out-list',
                name: '对外渠道',
                component: () => import('@/views/channel/List.vue'),
                meta: { title: '对外渠道', keepAlive: true, depth: 30 },
            },
            {
                path: 'out-list-center',
                name: '对外渠道个人中心配置',
                component: () => import('@/views/channel/ListCenter.vue'),
                meta: { title: '对外渠道个人中心配置', keepAlive: true, depth: 40 }
            },
            {
                path: 'sale-list',
                name: '销售渠道',
                component: () => import('@/views/channel/List.vue'),
                meta: { title: '销售渠道', keepAlive: true, depth: 30 }
            },
            {
                path: 'edit',
                name: '渠道编辑',
                component: () => import('@/views/channel/Edit.vue'),
                meta: { title: '渠道编辑', hidden: true, depth: 40 }
            },
            {
                path: 'block',
                name: '屏蔽信息',
                component: () => import('@/views/channel/Block.vue'),
                meta: { title: '屏蔽信息', hidden: true, depth: 40 }
            },
            {
                path: 'ordinary-open',
                name: '品牌/商品开放',
                component: () => import('@/views/channel/OrdinaryOpen.vue'),
                meta: { title: '品牌/商品开放', hidden: true, depth: 40 }
            },
            {
                path: 'open',
                name: '开放信息',
                component: () => import('@/views/channel/Open.vue'),
                meta: { title: '开放信息', hidden: true, depth: 40 }
            },
            {
                path: 'open-special',
                name: '特殊品牌开放信息',
                component: () => import('@/views/channel/OpenSpecial.vue'),
                meta: { title: '特殊品牌开放信息', hidden: true, depth: 40 }
            },
            {
                path: 'channel-accountsList',
                name: '结算配置',
                component: () => import('@/views/channel/ChannelAccountsList.vue'),
                meta: { title: '结算配置', hidden: true, depth: 40 }
            },
            {
                path: 'channel-accounts-info',
                name: '结算详情',
                component: () => import('@/views/channel/ChannelAccountsInfo.vue'),
                meta: { title: '结算详情', hidden: true, depth: 40 }
            },
            {
                path: 'base-brand',
                name: '基础品牌池',
                component: () => import('@/views/channel/BaseBrand.vue'),
                meta: { title: '基础品牌池' }
            },
            {
                path: 'discount-brand',
                name: '品牌折扣',
                component: () => import('@/views/channel/DiscountBrand.vue'),
                meta: { title: '品牌折扣', hidden: true, depth: 40 }
            },
            {
                path: 'discount-product',
                name: '商品折扣',
                component: () => import('@/views/channel/DiscountProduct.vue'),
                meta: { title: '商品折扣', hidden: true, depth: 50 }
            },
            {
                path: 'whitelist',
                name: '限制商品',
                component: () => import('@/views/channel/Whitelist.vue'),
                meta: { title: '特殊品牌/商品' }
            },
            {
                path: 'theme',
                name: '主题配置',
                component: () => import('@/views/channel/Theme.vue'),
                meta: { title: '主题配置' }
            },
            {
                path: 'brand-sort',
                name: '品牌馆',
                component: () => import('@/views/channel/BrandSort.vue'),
                meta: { title: '品牌馆' }
            },
            {
                path: 'product-sort',
                name: '商品排序',
                component: () => import('@/views/channel/ProductSort.vue'),
                meta: { title: '商品排序' }
            },
            {
                path: 'contract-list',
                name: '合同归档',
                component: () => import('@/views/channel/ContractList.vue'),
                meta: { title: '合同归档', keepAlive: true, depth: 30 }
            },
            {
                path: 'contract-edit',
                name: '合同编辑',
                component: () => import('@/views/channel/ContractEdit.vue'),
                meta: { title: '合同编辑' }
            },
            {
                path: 'contract-warning',
                name: '合同提醒',
                component: () => import('@/views/channel/ContractWarning.vue'),
                meta: { title: '合同提醒' }
            },
            {
                path: 'channel-group',
                name: '渠道分组',
                component: () => import('@/views/channel/ChannelGroup.vue'),
                meta: { title: '渠道分组', keepAlive: true, depth: 30 }
            },
            {
                path: 'channel-group-edit',
                name: '渠道分组编辑',
                component: () => import('@/views/channel/ChannelGroupEdit.vue'),
                meta: { title: '渠道分组编辑' }
            },
            {
                path: 'channel-group-block',
                name: '渠道分组屏蔽',
                component: () => import('@/views/channel/ChannelGroupBlock.vue'),
                meta: { title: '渠道分组屏蔽' }
            },
            {
                path: 'channel-group-discount-log',
                name: '渠道分组折扣配置记录',
                component: () => import('@/views/channel/ChannelGroupDiscountLog.vue'),
                meta: { title: '渠道分组折扣配置记录' }
            },
            {
                path: 'channel-service-rate',
                name: '渠道服务费率',
                component: () => import('@/views/channel/ChannelServiceRate.vue'),
                meta: { title: '渠道服务费率',badge: 'jb_service_fee' }
            },
            {
                path: 'single-channel-service-rate',
                name: '某渠道服务费率',
                component: () => import('@/views/channel/ChannelServiceRate.vue'),
                meta: { title: '某渠道服务费率',badge: 'jb_service_fee' }
            },
            {
                path: 'recharge-setting',
                name: '渠道付款设置',
                component: () => import('@/views/channel/RechargeSetting.vue'),
                meta: { title: '付款设置' }
            },
            {
                path: 'product-group-list',
                name: '商品批量设置',
                component: () => import('@/views/channel/ProductGroup.vue'),
                meta: { title: '商品批量设置' }
            },
            {
                path: 'product-group-edit',
                name: '商品批量设置编辑',
                component: () => import('@/views/channel/ProductGroupEdit.vue'),
                meta: { title: '商品批量设置编辑' }
            },
        ]
    }
]

export default channelRouter